import { inject } from '@angular/core';
import {
  HttpHandlerFn,
  HttpHeaders,
  HttpRequest,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, catchError, tap, throwError } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromSelectors from '../store/selectors';
import { MultiLanguageService } from '@app/share/translate';
import Storage from '@core/utils/storage';

export function AuthorizationInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> {
  let DeviceId: string = localStorage.getItem('uId') ?? '';
  let DeviceToken: string = localStorage.getItem('oTokenId') ?? '-';
  const _store = inject(Store<{ accessToken: string }>);
  const translate = inject(MultiLanguageService);
  let authorization: string | undefined;
  let tempToken: string | undefined;
  let acceptLanguage = translate.currentLanguage();
  const storeMarket = localStorage.getItem('storeId') ?? '1';

  let accessToken$: Observable<string | undefined> = _store.select(
    fromSelectors.getTokenState
  );

  accessToken$.subscribe((token) => {
    if (token) {
      authorization = token;
    }
  });

  translate.lang$.subscribe((lang) => {
    acceptLanguage = lang;
  });

  const core = JSON.parse(JSON.stringify(Storage.get('core', '')));
  tempToken = core?.login?.authorization?.tempToken;

  const isWhiteList =
    !request.url.includes('/Register') &&
    !request.url.includes('/Login') &&
    !request.url.includes('/Home') &&
    !request.url.includes('/LoginWithSocialMedia') &&
    !request.url.includes('/ContinueAsGuest') &&
    !request.url.includes('/ForgotPasswordByEmail') &&
    !request.url.includes('/VerifyActivationCode') &&
    !request.url.includes('/ResetPassword') &&
    !request.url.includes('/RefreshToken');

  // ✅ Append 'lang=ar' as a query parameter
  const updatedParams = request.params.set('lang', acceptLanguage);
  if (isWhiteList) {
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${authorization}`,
        ApiToken: '123456789',
        'Accept-Language': acceptLanguage,
        Currency: storeMarket === '1' ? 'KWD' : 'BHD',
        StoreId: storeMarket,
        DeviceId: DeviceId,
        DeviceName: 'web',
        DeviceType: '3',
      },
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: updatedParams, // 🔥 Add 'lang=ar' here
    });
  } else if (
    request.url.includes('/VerifyActivationCode') ||
    request.url.includes('/ResetPassword')
  ) {
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${tempToken}`,
        ApiToken: '123456789',
        'Accept-Language': acceptLanguage,
        Currency: storeMarket === '1' ? 'KWD' : 'BHD',
        StoreId: storeMarket,
        DeviceId: DeviceId,
        DeviceName: 'web',
        DeviceType: '3',
      },
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: updatedParams, // 🔥 Add 'lang=ar' here
    });
  } else {
    request = request.clone({
      setHeaders: {
        ApiToken: '123456789',
        'Accept-Language': acceptLanguage,
        Currency: storeMarket === '1' ? 'KWD' : 'BHD',
        StoreId: storeMarket,
        DeviceId: DeviceId,
        DeviceName: 'web',
        DeviceType: '3',
      },
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: updatedParams, // 🔥 Add 'lang=ar' here

    });
  }

  return next(request).pipe(
    tap((event) => {
      if (event instanceof HttpResponse) {
        //console.log('✅ Response received:', event);
      }
    }),
    catchError((error: HttpErrorResponse) => {
      let errorMessage = 'An unknown error occurred!';

      if (error.error instanceof ErrorEvent) {
        errorMessage = `Client-side error: ${error.error.message}`;
      } else {
        switch (error.status) {
          case 400:
            errorMessage = 'Bad Request: Invalid input!';
            break;
          case 401:
            errorMessage = 'Unauthorized: Please log in again!';
            break;
          case 403:
            errorMessage = 'Forbidden: You do not have permission!';
            break;
          case 404:
            errorMessage = 'Not Found: The requested resource was not found!';
            break;
          case 500:
            errorMessage = 'Internal Server Error: Please try again later!';
            break;
          default:
            errorMessage = `Error ${error.status}: ${error.message}`;
        }
      }

      console.error('❌ Error occurred:', errorMessage);
      return throwError(() => new Error(errorMessage));
    })
  );
}
